import styled from 'styled-components'

export const NFTSellModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;

  .category-error {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.secondary1};
    font-weight: bold;
  }
`

export const NFTSellModalMeta = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
`

export const NFTSellModalForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .form-item {
    width: 100%;
    border: solid 1px ${({ theme }) => theme.bg2};
    padding: 0.5rem;
    margin-bottom: 1rem;

    .form-input {
      width: 100%;
    }

    .price-amount {
      width: 100%;
      display: flex;
      margin-top: 0.4rem;
      .price-currency {
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 0.5rem;
        cursor: pointer;
        background-color: ${({ theme }) => theme.bg7};
        padding: 0.5rem;

        .currency-symbol {
          margin-left: 0.5rem;
        }

        .yts-logo {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          img {
            width: 24px;
            border-radius: 50%;
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
`

export const NFTSellModalButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .nft-button {
    width: 45%;
  }
`

export const NFTSaleTypeWrapper = styled.div`
  width: 100%;
  display: flex;

  .sale-type-item {
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    margin-right: 0.5rem;
    border: solid 1px ${({ theme }) => theme.text1};
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 0.8rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &.active {
      border: solid 1px ${({ theme }) => theme.yetiBlue};

      color: ${({ theme }) => theme.yetiBlue};

      svg {
        fill: ${({ theme }) => theme.yetiBlue};
      }
    }

    &.disabled {
      opacity: 0.5;
    }

    :last-child {
      margin-right: 0;
    }

    svg {
      width: 35px;
      height: 35px;
      fill: ${({ theme }) => theme.text1};
    }

    .sale-type-item-text {
      width: 100%;
      padding: 0 1rem;
      word-break: break-word;
      margin-top: 0.5rem;
    }

    .coming-soon {
      position: absolute;
      left: -30px;
      top: 15px;
      transform: rotate(-45deg);
      padding: 0.5rem;
      color: ${({ theme }) => theme.text3};
      background-color: ${({ theme }) => theme.text1};
      width: 115px;
      text-align: center;
      font-size: 0.7rem;
    }
  }
`
